// These are the ids from server
export enum TableColumnId {
  Budget = 1,
  Forecast = 2,
  Actual = 3,
  Committed = 4,
  Planned = 5,
  Available = 6,
}
